import React from 'react';
import { connect } from 'react-redux';

import { formatDayToYearLong } from 'utils/date/format.util';

import HeaderMenu from 'reports/Common/HeaderMenu';
import ReportsMainLayoutContainer from 'reports/Common/ReportsMainLayout';
import { Tables } from 'reports/consts';
import Hours from 'reports/HoursWorked/Hours.component';

import SalonHoursWorkedByCategoryOrServiceTableContainer from './SalonHoursWorkedByCategoryOrServiceTable';
import StylistHoursByCategoryAndServiceContainer from './StylistHoursByCategoryAndService';

const ReportsProps = ['salonHoursReport'];

export class HoursWorkedReports extends ReportsMainLayoutContainer {
  constructor(props) {
    super(props);
    this.state = {
      headerData: {
        name: 'Hours',
        items: [
          {
            id: Tables.WorkingHoursStylist,
            name: 'Staff',
            onClick: () => {
              this.setTables(Tables.WorkingHoursStylist);
            },
          },
          {
            id: Tables.HoursWorkedByCategory,
            name: 'Category',
            onClick: () => {
              this.setTables(Tables.HoursWorkedByCategory);
            },
          },
          {
            id: Tables.HoursWorkedByStylistByCategoryAndService,
            name: 'Staff member per Category/Service',
            onClick: () => {
              this.setTables(Tables.HoursWorkedByStylistByCategoryAndService);
            },
          },
        ],
      },
      title: '',
      shownTables: 0,
    };
  }

  UNSAFE_componentWillMount() {
    this.setTables(Tables.WorkingHoursStylist);
  }

  checkIfAllDataIsLoaded = () => ReportsProps.every((prop) => this.props[prop].lastRequestResponse);

  render() {
    return (
      <div className="has-protipbox hours">
        <div className="new-wraper">
          {!this.checkIfAllDataIsLoaded() && (
            <div className="spinner-container">
              <div className="load-spinner" />
            </div>
          )}
          <HeaderMenu data={this.state.headerData} selectedId={this.state.shownTables} />
          {this.props.salonHoursReport.lastRequestResponse && (
            <div className="box hours">
              <div className="banner default full-width hour">
                <div style={{ width: '100%' }}>
                  <div className="cfix relative">
                    <span className="img-emoji-1" role="img" aria-labelledby="lamp">
                      💡
                    </span>
                    <div className="text">
                      <strong>Pro tip:</strong>
                      Hours are calculated using the salon opening hours, busy time i.e time with client and time off
                      that is booked in the diary.
                    </div>
                  </div>
                  <div className="cfix relative">
                    <span className="img-emoji-2" role="img" aria-labelledby="lamp">
                      💡
                    </span>
                    <div className="text">
                      <strong>Pro tip:</strong>
                      Time off can be added as one off blocks or repeating (every X number of weeks) to create a rota.
                    </div>
                  </div>
                </div>
                <div className="link">
                  <a
                    href="https://help.getslick.com/en/articles/1703114-all-you-need-to-know-about-staff-time-off"
                    alt="Heed help"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Need Help?
                  </a>
                </div>
              </div>
              <div className="title" style={{ marginTop: '18px' }}>{`${this.state.title}`}</div>

              <Hours
                startDate={formatDayToYearLong(this.props.uniqueVisitsReport.start_date)}
                endDate={formatDayToYearLong(this.props.uniqueVisitsReport.end_date)}
              />

              {!!(this.state.shownTables & Tables.HoursWorkedByCategory) && (
                <SalonHoursWorkedByCategoryOrServiceTableContainer
                  startDate={formatDayToYearLong(this.props.uniqueVisitsReport.start_date)}
                  endDate={formatDayToYearLong(this.props.uniqueVisitsReport.end_date)}
                  data={this.props.salonHoursReport.lastRequestResponse}
                  type="Category"
                />
              )}

              {!!(this.state.shownTables & Tables.HoursWorkedByStylistByCategoryAndService) && (
                <StylistHoursByCategoryAndServiceContainer
                  startDate={formatDayToYearLong(this.props.uniqueVisitsReport.start_date)}
                  endDate={formatDayToYearLong(this.props.uniqueVisitsReport.end_date)}
                  data={this.props.salonHoursReport.lastRequestResponse}
                />
              )}
            </div>
          )}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const {
    currentSalon: { id: salonId, stylistList },
    reports,
  } = state;
  const { salonHoursReport, stylistIDInCalendarOrder, uniqueVisitsReport } = reports;
  return {
    salonId,
    stylistList,
    salonHoursReport,
    stylistIDInCalendarOrder,
    uniqueVisitsReport,
  };
}

export function mapDispatchToProps() {
  return {};
}

export default connect(mapStateToProps, mapDispatchToProps)(HoursWorkedReports);
